import { Wizard } from './Wizard'

// eslint-disable-next-line import/no-default-export
export default Wizard
